var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReportRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / report"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 28.3333C20.4722 28.3333 20.8683 28.1733 21.1883 27.8533C21.5083 27.5333 21.6678 27.1378 21.6667 26.6667C21.6656 26.1956 21.5056 25.8 21.1867 25.48C20.8678 25.16 20.4722 25 20 25C19.5278 25 19.1322 25.16 18.8133 25.48C18.4944 25.8 18.3344 26.1956 18.3333 26.6667C18.3322 27.1378 18.4922 27.5339 18.8133 27.855C19.1344 28.1761 19.53 28.3356 20 28.3333ZM18.3333 21.6667H21.6667V11.6667H18.3333V21.6667ZM13.75 35L5 26.25V13.75L13.75 5H26.25L35 13.75V26.25L26.25 35H13.75ZM15.1667 31.6667H24.8333L31.6667 24.8333V15.1667L24.8333 8.33333H15.1667L8.33333 15.1667V24.8333L15.1667 31.6667Z",
    fill: "#F30D52"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReportRed);
export default __webpack_public_path__ + "static/media/icon-report-red.9b36214fb66990766bc3aaa8b327beba.svg";
export { ForwardRef as ReactComponent };